/* Model */
class EquipmentTypeModel extends App.Models.BaseModel {
  modelUrl = 'EquipmentType';
}

App.Models.EquipmentType = EquipmentTypeModel;

/* Collection */
class EquipmentTypeCollection extends App.Collections.BaseCollection {
  url = 'EquipmentType';
  model = App.Models.EquipmentType;
}

App.Collections.EquipmentTypes = EquipmentTypeCollection;

/* Router */
class EquipmentTypeRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'EquipmentType';
    const model = App.Models.EquipmentType;
    const collectionClass = App.Collections.EquipmentTypes;

    super(entityName, model, collectionClass);
  }

  hideSizeFields = () => {
    const fields = [
      'maximumEquipmentHeight',
      'grossEquipmentWeight',
      'axleCount',
      'weight'
    ];

    fields.forEach((item) => App.Forms.EquipmentType.form.fields[item].hide());
  };

  hideNavSettingsSection = () => {
    const inputSelector = '#EquipmentType_minimumDistance label';
    const inputPerDistanceRateKm = '#EquipmentType_perDistanceRateKm label';

    Monet.FormBuilder.appendUnitySystemMetricToLabel(inputSelector);
    Monet.FormBuilder.appendUnitySystemMetricToLabel(inputPerDistanceRateKm);

    const navFeatureFlag =
      GreenmileReduxStore.getState().configuration.featureStates.get('GM_NAV');
    const { enabled } = navFeatureFlag;

    if (!enabled) {
      const newNavSettingsSection = document.querySelector(
        '#EquipmentType div#form_and_grid div[key="new_nav_settings"]'
      );
      const editNavSettingsSection = document.querySelector(
        '#EquipmentType div#form_and_grid div[key="edit_nav_settings"]'
      );

      if (newNavSettingsSection) {
        newNavSettingsSection.style.display = 'none';
      }

      if (editNavSettingsSection) {
        editNavSettingsSection.style.display = 'none';
      }
    }
  };

  removeSettingsFromPayloadIfNavIsDisabled = (payload) => {
    const navFeatureFlag =
      GreenmileReduxStore.getState().configuration.featureStates.get('GM_NAV');
    const { enabled } = navFeatureFlag;

    const navSettingsKeys = [
      'avoidAlreadyUsedRoutes',
      'avoidShortTurns',
      'avoidTollRoads',
      'avoidTunnels',
      'tunnelCategory'
    ];

    const cleanedData = { ...payload };

    if (!enabled) {
      navSettingsKeys.forEach((key) => {
        if (cleanedData.hasOwnProperty(key)) {
          delete cleanedData[key];
        }
      });
    }

    return cleanedData;
  };

  beforeCreate = (model) => {
    model.attributes = this.removeSettingsFromPayloadIfNavIsDisabled(
      model.attributes
    );
  };

  beforeUpdate = (data) => {
    data = this.removeSettingsFromPayloadIfNavIsDisabled(data);
  };

  afterCreateForm = () => {
    this.hideNavSettingsSection();
    this.hideSizeFields();
  };
}

App.Routers.EquipmentType = EquipmentTypeRouter;
